import { render, staticRenderFns } from "./BlogPostCard.vue?vue&type=template&id=f032af52&scoped=true&"
import script from "./BlogPostCard.vue?vue&type=script&lang=js&"
export * from "./BlogPostCard.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostCard.vue?vue&type=style&index=0&id=f032af52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f032af52",
  null
  
)

export default component.exports